export default __webpack_public_path__ + "static/media/howto-img-01@small.aae280d1.jpg";